import React, { useState, useEffect } from "react";
import "./FatcaCRSDeclaration.modules.css";
import "./ClientClassification.modules.css";
import p1 from "../../../../assets/images/Sharjah/Onboarding/p1.png";
import p2 from "../../../../assets/images/Sharjah/Onboarding/p2.png";
import p1ADCB from "../../../../assets/images/ADCB/Onboarding/p1.png";
import p2ADCB from "../../../../assets/images/ADCB/Onboarding/p2.png";
import { InfoCircleFill } from "react-bootstrap-icons";
import i18next from "i18next";
import * as Constants from "../../../../constants/Constants";
import * as Helpers from "../../../../global/Helpers";
import * as utils from "../../../../global/utils";
import { useTranslation } from "react-i18next";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import SessionExpiredPOPup from "../../SessionExpiredPOPup/SessionExpiredPOPup";

const FatcaCRSDeclaration7 = (props) => {
  const { t } = useTranslation();

  return (
    <div className="FatcaCRSDeclaration">
      <div className="form-container">
        <form className="dropdown-form">
          <div className="form-group">
            <h5>{t("client_classification")}</h5>
            <div className="seekbar-wrapper">
              <ClientClassification saveKycDataAPI={props.saveKycDataAPI} setIsCallAPI={props.setIsCallAPI} IsCallAPI={props.IsCallAPI} />
            </div>
          </div>
          {/* <button type="submit" className="submit-button">Submit</button> */}
        </form>
      </div>
    </div>
  );
};

function ClientClassification(props) {
        const companyName = localStorage.getItem(Constants.localStorageConstants.company_name)?.toUpperCase();


  const img1 = companyName === "ADCB" ? p1ADCB : p1;
  const img2 = companyName === "ADCB" ? p2ADCB : p2;
  const { t } = useTranslation();

  const [selected, setSelected] = useState("");
  const [ClientClassification, setClientClassification] = useState([]);

  // useEffect(() => {
  //     fetchClientClassification();
  // }, [i18next.language]);

  useEffect(() => {
    ;
    if (props.IsCallAPI) saveKycDataFun();
  }, [props.IsCallAPI]);

  function validateSubmit() {
    ;
    if (selected === "") {
      Helpers.errorNotify(t("Please fill Client Classification"), i18next.language);
      props.setIsCallAPI(false);
      return false;
    }
    return true;
  }

  const saveKycDataFun = () => {
    ;
    if (!validateSubmit()) return;

        var result = Helpers.getScreenIdByGroupAndName("Client Classification");
    
    var Items = [
      { ID: "26", Value: selected },
      { ID: "258", Value: "1" },
      { ID: "288", Value: result?.GROUP_ID || "" },
      { ID: "287", Value: result?.SCREEN_ID || "" },
    ];
    props.saveKycDataAPI(Items);
  };

  const handleClick = (value) => {
    setSelected(value);
  };

  const fetchClientClassification = async () => {


    ;
    try {
      const data = { FormType: "1", Lang: i18next.language === "ar" ? "AR" : "EN" };
      var response = utils.CallKYCAPI(Constants.GetRiskClassification, data);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "success") {
            setClientClassification(response.data.resData);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return <SessionExpiredPOPup setRedirect={null} onClose={onClose} />;
              },
            });
          } else {
            setClientClassification([]);
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("fetchClientClassification", error);
        });
    } catch (error) {
      console.error("Error posting data fetchClientClassification:", error);
    }
  };

  return (
    <div className="ClientClassification-container">
      <label htmlFor="dropdown5" className="form-label">
        {t("based_on_classification_professional")}
      </label>

      <div className="button-group">
        <div className="btn-container">
          <button
            style={{ marginInline: "10px" }}
            className={`frequency-button ${selected === "1" ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              handleClick("1");
            }}>
            <img src={img1} />
            <div> {t("professional")}</div>
          </button>
          <div className="InfoCircleDiv">
            <span style={{ paddingInline: "8px" }}> {t("KnowMore")}</span>
            <InfoCircleFill size={15} color="#E37D00" />
          </div>
        </div>
        <div className="btn-container">
          <button
            className={`frequency-button ${selected === "2" ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              handleClick("2");
            }}>
            <img src={img2} />
            <div> {t("ordinary")} </div>
          </button>
          <div className="InfoCircleDiv">
            <span style={{ paddingInline: "8px" }}> {t("KnowMore")}</span>
            <InfoCircleFill size={15} color="#E37D00" />
          </div>
        </div>
      </div>

      <label htmlFor="dropdown5" className="form-label">
        {t("disclaimer_change_selection")}
      </label>
    </div>
  );
}
export default FatcaCRSDeclaration7;
